module.exports = global["jQuery"] = require("-!E:\\leadto_project\\z中船发动机\\zhongchuan\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");